'use client';

import { handleDispatchInteractionEvent } from "@/helpers/adobe";
import Link from "next/link";

const CtaDispatch = ({ href, interaction, children, className, id, dataTestId }) => {
    return (<Link
        href={href}
        passHref
        legacyBehavior
    >
        <a
            id={id}
            data-testid={dataTestId}
            className={className}
            onClick={() => handleDispatchInteractionEvent(interaction)}
            onKeyDown={() => handleDispatchInteractionEvent(interaction)}>
            {children}
        </a>
    </Link>)
}

export default CtaDispatch;